import styled from '@emotion/styled';
import { bodyB, captionM, subTitle2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const Container = styled.div`
  display: flex;
  width: 320px;
  padding: 20px;
  justify-content: flex-end;
  align-items: flex-start;
  align-content: flex-start;
  flex-direction: column;
  gap: 20px;
  flex-wrap: wrap;

  border-radius: 16px;
  background: #fff;

  box-shadow: 0px 8px 24px 0px rgba(95, 102, 107, 0.12);
`;

export const Title = styled.div`
  white-space: pre-line;
  align-self: stretch;

  ${subTitle2};
  color: ${vars.neutral[100]};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 280px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

export const CloseButton = styled.button`
  display: flex;
  min-width: 100px;
  padding: 13px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #eef3f6;

  ${bodyB}
  color: #3a3e41;
`;

export const RetryButton = styled.button`
  display: flex;
  min-width: 100px;
  padding: 13px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #141617;

  ${bodyB}
  color: #fff;
`;

export const Description = styled.div`
  ${captionM};
  color: ${vars.neutral[70]};
`;
